module.exports = __webpack_public_path__ + "img/img-10.dd3011ab.png";